import React, { useEffect, useState } from 'react';
import { Modal, Table } from 'react-bootstrap';
// import NotFound from "../../../assets/images/not_found.jpg";
import { useQuery, useQueryClient } from 'react-query';
import {
  callAdminMemberListing,
  deleteMemberListing,
  callAdminUpdateUser,
} from '../../../api-services';
import Pagination from '../../../helper/Pagination';
import Dropdown from 'react-bootstrap/Dropdown';
import { Spinner } from '../../../helper/Spinner';
import { useMutation } from 'react-query';
import swal from 'sweetalert';
import MemberEditModal from '../modal/MamberEditModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEllipsisV,
  faEdit,
  faTrash,
  faUserSlash,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
const MemberDetailsModal = ({
  data,
  setOpenModal,
  setModalData,
  openModal,
}) => {
  const queryClient = useQueryClient();
  const [currentPage, setCurrentPage] = useState(1);
  const [openMemberEditModal, setOpenMemberEditModal] = useState(false);
  const [memberEditModalData, setMemberEditModalData] = useState({});

  const handleClose = () => {
    setOpenModal(false);
    setModalData({});
  };

  const {
    isLoading,
    data: dataMemberDetails,
    refetch,
  } = useQuery(
    'admin-member-listing',
    () =>
      callAdminMemberListing({
        user_id: data.id,
        page: currentPage,
      }),
    {
      select: (data) => data.data || [],
      cacheTime: 0,
      staleTime: 0,
    },
  );

  const onChangePage = async (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  // *********************Function for Activate Button******************

  const { mutateAsync: mutateAsyncActive } = useMutation(
    'update-user',
    callAdminUpdateUser,
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message,
          icon: 'success',
        }).then(() => {
          queryClient.invalidateQueries('admin-member-listing');
        });
      },
      onError: (error) => {
        swal({
          title: 'Error!',
          text: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );

  const handleActivateMember = async (data) => {
    let payload = {
      uuid: data.uuid,
      is_active: 1,
      action_type: 'update',
    };
    swal({
      text: 'Do You Want To Activate This Member',
      icon: 'warning',
    }).then(async () => {
      try {
        await mutateAsyncActive(payload);
      } catch (error) {
        console.error(error);
      }
    });
  };

  // *********************Function for deActivate Button******************

  const { mutateAsync: mutateAsyncDeactive } = useMutation(
    'update-user',
    callAdminUpdateUser,
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message,
          icon: 'success',
        }).then(() => {
          queryClient.invalidateQueries('admin-member-listing');
        });
      },
      onError: (error) => {
        swal({
          title: 'Error!',
          text: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );

  const handleDeactivateMember = async (data) => {
    let payload = {
      uuid: data.uuid,
      is_active: 0,
      action_type: 'update',
    };
    swal({
      text: 'Do You Want To Deactivate This Member',
      icon: 'warning',
    }).then(async () => {
      try {
        await mutateAsyncDeactive(payload);
      } catch (error) {
        console.error(error);
      }
    });
  };

  // *************** delete member  ***************

  const { mutateAsync } = useMutation('delete-member', deleteMemberListing, {
    onSuccess: (data) => {
      swal({
        text: data?.data?.message,
        icon: 'success',
      }).then(() => {
        queryClient.invalidateQueries('admin-member-listing');
      });
    },
    onError: (error) => {
      swal({
        title: 'Error!',
        text: error?.response?.data?.message,
        type: 'danger',
        icon: 'error',
      });
    },
  });

  const deleteMemberList = (value) => {
    swal({
      text: 'You Want To Delete This Member ?',
      buttons: true,
      icon: 'warning',
    }).then(async (willDelete) => {
      if (willDelete) {
        let payload = {
          id: data?.id,
          uuid: value?.uuid,
          action_type: 'admin_delete',
        };
        await mutateAsync(payload);
      }
    });
  };

  const editMemberModal = (data) => {
    setOpenMemberEditModal(true);
    setMemberEditModalData(data);
  };

  return (
    <>
      <Modal
        size="lg"
        animation={false}
        centered
        show={openModal}
        onHide={() => handleClose()}
        keyboard={false}
        backdrop="static"
      >
        <div className="modal-header">
          <h5 className="modal-title ">Member Details</h5>
        </div>
        <div className="modal-body btn-light-blue">
          <div className="row">
            <div className="col-md-12 modal-table-scroll">
              <Table className="table_custom" hover size="sm">
                {dataMemberDetails &&
                  dataMemberDetails.data &&
                  dataMemberDetails?.data?.length > 0 && (
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th style={{ textAlign: 'center' }}>Phone</th>
                        <th style={{ textAlign: 'center' }}>Status</th>
                        <th style={{ textAlign: 'center' }}>Action</th>
                      </tr>
                    </thead>
                  )}
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan="10" rowSpan="10" align="center">
                        <Spinner />
                      </td>
                    </tr>
                  ) : dataMemberDetails &&
                    dataMemberDetails.data &&
                    dataMemberDetails?.data?.length > 0 ? (
                    dataMemberDetails?.data?.map((data, i) => {
                      const { name, email, phone, is_active } = data;
                      return (
                        <tr key={i}>
                          <td>{name ? name : 'N/A'}</td>
                          <td>{email ? email : 'N/A'}</td>
                          <td align="center">{phone ? phone : 'N/A'}</td>

                          <td align="center" style={{ width: '12%' }}>
                            {is_active === 1 ? (
                              <a className="text-success" href={void 0}>
                                Active
                              </a>
                            ) : (
                              <a className="text-danger" href={void 0}>
                                Inactive
                              </a>
                            )}
                          </td>

                          <td align="center">
                            <span>
                              <Dropdown className="dropdown_dot">
                                <Dropdown.Toggle
                                  id="dropdown-basic"
                                  className="btn-light-blue btn-action "
                                >
                                  <FontAwesomeIcon icon={faEllipsisV} />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    href={void 0}
                                    onClick={() => editMemberModal(data)}
                                  >
                                    <FontAwesomeIcon icon={faEdit} /> Edit
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    href={void 0}
                                    onClick={() => deleteMemberList(data)}
                                  >
                                    <FontAwesomeIcon icon={faTrash} /> Delete
                                  </Dropdown.Item>

                                  {is_active === 1 ? (
                                    <Dropdown.Item
                                      href="#/action-3"
                                      onClick={() =>
                                        handleDeactivateMember(data)
                                      }
                                    >
                                      <FontAwesomeIcon icon={faUserSlash} />
                                      Deactivate
                                    </Dropdown.Item>
                                  ) : (
                                    <Dropdown.Item
                                      href="#/action-3"
                                      onClick={() => handleActivateMember(data)}
                                    >
                                      <FontAwesomeIcon icon={faUser} /> Activate
                                    </Dropdown.Item>
                                  )}
                                </Dropdown.Menu>
                              </Dropdown>
                            </span>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <td colSpan="4" align="center" className="text-center">
                      No Record Found
                    </td>
                  )}
                </tbody>
              </Table>
              {dataMemberDetails &&
              dataMemberDetails.data &&
              dataMemberDetails?.data?.length > 0 ? (
                <Pagination
                  pageSize={dataMemberDetails?.lastpage}
                  items={dataMemberDetails?.data}
                  onChangePage={onChangePage}
                  total={dataMemberDetails?.TotalRecord}
                  currentPage={currentPage}
                />
              ) : null}
            </div>

            <div className="col-md-12 text-right mt-2">
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => handleClose()}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <MemberEditModal
        setOpenMemberEditModal={setOpenMemberEditModal}
        openMemberEditModal={openMemberEditModal}
        setMemberEditModalData={setMemberEditModalData}
        memberEditModalData={memberEditModalData}
      />
    </>
  );
};

export default MemberDetailsModal;
